import { Spinner, SpinnerOptions } from "spin.js";
import { ref } from "vue";

export const useAsyncSpinner = async (
  callback: () => Promise<void>,
  opts?: SpinnerOptions | undefined,
  delay?: number | 2000
): Promise<void> => {
  let spinner = new Spinner(opts);

  const timeout = setTimeout(() => {
    const el = document.querySelector<HTMLElement>(".spinner-container");
    if (el) {
      el.style.zIndex = "1";
      spinner = spinner.spin(el);
    }
  }, delay);
  try {
    await callback();
  } finally {
    if (timeout) {
      clearTimeout(timeout);
    }
    spinner = spinner.stop();
    const el = document.querySelector<HTMLElement>(".spinner-container");
    if (el) {
      el.style.zIndex = "-1";
    }
  }
};

export const useSpinner = () => {
  const spinner = ref<Spinner>(new Spinner());
  const spin = () => {
    const el = document.querySelector<HTMLElement>(".spinner-container");
    if (el) {
      el.style.zIndex = "1";
      spinner.value.spin(el);
    }
  };
  const stop = () => {
    spinner.value.stop();
    const el = document.querySelector<HTMLElement>(".spinner-container");
    if (el) {
      el.style.zIndex = "-1";
    }
  };
  return { spin, stop };
};

export const useSyncSpinner = (callback: () => void, opts?: SpinnerOptions | undefined): void => {
  let spinner = new Spinner(opts);
  const timeout = setTimeout(() => {
    spinner = spinner.spin(document.querySelector<HTMLElement>("#app") as HTMLElement);
  }, 2000);
  try {
    callback();
  } catch (e) {
    console.error(e);
  } finally {
    if (timeout) {
      clearTimeout(timeout);
    }
    spinner.stop();
  }
};
